// extracted by mini-css-extract-plugin
export default {"row":"styles_row__Zlwto","input":"styles_input__4IsL4","btn":"styles_btn__dYGwj","alignIcon":"styles_alignIcon__lidtv"};